import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import ComboBox from 'Components/ComboBox'
import { Input } from 'Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePutRequest } from 'utils/api'
import urls from 'utils/urls'
import { UTILISATION } from 'utils/constants'
import { makePostRequest } from 'utils/api'
import CreateCompany from '../CreateCompany'
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import CreateDocument from '../CreateOperationForm/CreateDocument'
import { convertToMuiDate } from 'utils/helpers'
import { FixedSizeList as ListVirtualized } from 'react-window'

export default function EditOperationForm({ params, setSelected, updateOperation }) {
  const [open, setOpen] = useState(false)
  const [upui, setUpui] = useState(false)
  const [typeObject, setTypeObject] = useState(0)
  // const [docId, setDocId] = useState(false)
  const [addCompay, setAddCompay] = useState(false)
  const [submit, setSubmit] = useState(false)
  const [companys, setCompanys] = useState([])
  const [competence, setCompetence] = useState([])
  const [getPays, setPays] = useState([])
  const [selectedParcoursType, setSelectedParcoursType] = useState({})

  const [personName, setPersonName] = useState([])
  // console.log(params)

  const [openDialog, setOpenDialog] = useState(false)
  const [selectedItems, setSelectedItems] = useState([])
  const [searchQuery, setSearchQuery] = useState('')

  const filteredItems = competence.filter((item) =>
    item.label.toLowerCase().includes(searchQuery.toLowerCase()),
  )
  const handleOpenDialog = () => setOpenDialog(true)
  const handleCloseDialog = () => setOpenDialog(false)
  const handleCheckboxChange = (id) => {
    setSelectedItems((prevState) => {
      if (prevState.includes(id)) {
        return prevState.filter((selectedId) => selectedId !== id)
      }
      if (prevState.length < 5) {
        return [...prevState, id]
      }
      return prevState
    })
  }

  const renderRowCompetence = ({ index, style }) => {
    const item = filteredItems[index]
    return (
      <Box key={index} style={style}>
        <FormControlLabel
          control={
            <Checkbox
              checked={selectedItems.includes(item.id)}
              onChange={() => handleCheckboxChange(item.id)}
              disabled={selectedItems.length >= 5 && !selectedItems.includes(item.id)}
            />
          }
          label={item.label}
        />
      </Box>
    )
  }

  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    // console.log(event.target)
    // setPersonName(typeof value === 'string' ? value.split(',') : value)
    setPersonName(value)
    setValue('KeyCompetencies', value)
  }

  const typeParcour = [
    { label: 'Formation', id: 1 },
    { label: 'Expérience', id: 2 },
  ]
  const gmsalaryF = [
    { label: 'Par heure', id: 1 },
    { label: 'Par jour', id: 2 },
    { label: 'Par semaine', id: 3 },
    { label: 'Par mois', id: 4 },
    { label: 'Par an', id: 5 },
  ]
  const contractType = [
    { label: 'CDI', id: 1 },
    { label: 'Indépendant', id: 2 },
    { label: 'Freelance', id: 3 },
    { label: 'CDD', id: 4 },
    { label: 'Stage', id: 5 },
    { label: 'Contrat en alternance', id: 6 },
    { label: 'Intermittent du spectacle', id: 7 },
    { label: 'CDI temps partiels', id: 8 },
    { label: 'Service civique', id: 9 },
    { label: 'CDD temps partiels', id: 10 },
    { label: 'VIA / VIE', id: 11 },
    { label: 'Fonctionnaire', id: 12 },
    { label: 'Intérimaire', id: 13 },
  ]
  const log = async () => {
    // setSelectedParcoursType(typeParcour.find((e) => e.label === params.ParcoursType))
    setValue(
      'ParcoursType',
      typeParcour.find((e) => e.label === params.ParcoursType),
    )
    let tpt = typeParcour.find((e) => e.label === params.ParcoursType)
    if (tpt.id === 1) {
      setTypeObject(1)
    }
    if (tpt.id === 2) {
      setTypeObject(2)
    }
    setPersonName(params.KeyCompetencies)

    // setTypeObject(0)
    fetchCompanys()
    fetchCompetence()
    fetchPays()
    setSubmit(false)
    setOpen(true)
  }
  useEffect(() => {
    log()
    setSelectedItems(params.KeyCompetencies)
  }, [])

  const { handleSubmit, control, setValue, reset, getValues } = useForm({
    defaultValues: {
      id: params.id,
      ParcoursType: '',
      Name: params.Name,
      Entreprise: null,
      BeginDate: convertToMuiDate(params.BeginDate),
      CurrentPoste: params.CurrentPoste,
      EndDate: params.EndDate && convertToMuiDate(params.EndDate),
      // KeyCompetencies: params.KeyCompetencies,
      Country: null,
      City: params.City,
      ContractType: params.ContractType,
      Statut: params.Statut,
      CollectiveAgre: params.CollectiveAgre,
      GeneralInfo: params.GeneralInfo,
      TyHours: params.TyHours,
      SubTHours: params.SubTHours,
      hours: params.hours,
      // docid: params.docid,
      Gmsalary: params.Gmsalary,
      GmsalaryF: params.GmsalaryF,
      FinancialArrangement: params.FinancialArrangement,
      Advantage: params.Advantage,
    },
  })

  const allowSubmit = () => {
    setSubmit(true)
  }
  const handleClose = () => {
    setOpen(false)
    reset()
    setTypeObject(0)
    setPersonName([])
    // setDocId(false)
    setSubmit(false)
    setSelected(false)
  }

  const onSubmitPar = async (data) => {
    if (submit) {
      let payload = {}
      // let val = []
      // personName.forEach((n) => {
      //   let i = competence.filter((v) => v.label === n)
      //   val.push(i[0].id)
      // })

      payload = {
        ...data,
        Country: data.Country ? data.Country.id : null,
        Entreprise: data.Entreprise.id,
        ParcoursType: data.ParcoursType.label,
        KeyCompetencies: selectedItems,
        // docid: docId ? docId.id : null,
      }

      const response = await makePutRequest(
        urls.crudParcoursProOperations + params.id + '/',
        payload,
        {},
        true,
      )
      if (response.status === 200) {
        updateOperation()
        handleClose()
      }
    }
  }
  const fetchCompanys = async () => {
    const url = urls.fetchCompanys + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Name}`, id: v.id })
      })
      setValue(
        'Entreprise',
        filterTypes.find((e) => e.id === params?.entreprise.id),
      )
      setCompanys([...filterTypes])
    }
  }

  const fetchCompetence = async () => {
    const url = urls.fetchCompetence + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.CompetencesName}`, id: v.id })
      })
      setCompetence([...filterTypes])
    }
  }

  const fetchPays = async () => {
    const url = '/api/Social/get-countries/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterPays = []
      data.forEach((v) => {
        filterPays.push({ label: `${v.CountryCode}/${v.Designation}`, id: v.id })
      })
      setValue(
        'Country',
        filterPays.find((e) => e.id === params?.Country),
      )
      setPays([...filterPays])
    }
  }

  const clearData = () => {
    setSubmit(false)
    reset()
    setPersonName([])
    // setDocId(false)
  }
  return (
    <>
      {addCompay && (
        <CreateCompany
          fetchCompanys={fetchCompanys}
          setAddCompay={setAddCompay}
          headerText={typeObject === 1 ? 'Entreprise' : 'Organisation'}
        />
      )}
      {open && (
        <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
          <DialogTitle sx={{ backgroundColor: '#202020' }}>Modifier</DialogTitle>
          <form onSubmit={handleSubmit(onSubmitPar)}>
            <DialogContent>
              <ComboBox
                handleAutoComplete={(e, j) => {
                  if (j.id === 1) {
                    clearData()
                    setTypeObject(1)
                  } else if (j.id === 2) {
                    clearData()
                    setTypeObject(2)
                  }
                  setValue('ParcoursType', j)
                }}
                label="Type de parcours"
                data={typeParcour}
                name="ParcoursType"
                required={true}
                disabled
                selectedValue={getValues('ParcoursType')}
              />
              {typeObject === 1 ? (
                <>
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      required: true,
                      size: 'small',
                      type: 'text',
                    }}
                    rules={{ required: true }}
                    name="Name"
                    label="Intitulé poste ou formation (Name)"
                  />
                  <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <Box sx={{ width: '100%' }}>
                      <ComboBox
                        handleAutoComplete={(e, j) => {
                          setValue('Entreprise', j)
                          setUpui(!upui)
                        }}
                        label="Entreprise"
                        data={companys}
                        name="Entreprise"
                        required={true}
                        selectedValue={getValues('Entreprise')}
                      />
                    </Box>
                    <Box
                      sx={{
                        width: '30px',
                        marginTop: '12px',
                        display: 'flex',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        paddingX: '5px',
                      }}
                      onClick={() => setAddCompay(true)}
                    >
                      <AddIcon />
                    </Box>
                  </Box>
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      type: 'date',
                      required: true,
                      size: 'small',
                    }}
                    InputLabelProps={{ shrink: true }}
                    rules={{ required: true }}
                    name="BeginDate"
                    label="Date de début"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) => {
                          setValue('CurrentPoste', e.target.checked)
                          setUpui(!upui)
                        }}
                        checked={getValues('CurrentPoste')}
                      />
                    }
                    label="J'occupe cette fonction actuellement"
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      type: 'date',
                      // required: false,
                      size: 'small',
                    }}
                    InputLabelProps={{ shrink: true }}
                    // rules={{ required: false }}
                    name="EndDate"
                    label="Date de fin"
                  />
                  <TextField
                    sx={{ mb: 2 }}
                    label="Compétences clés"
                    fullWidth
                    size="small"
                    onClick={handleOpenDialog}
                    value={selectedItems
                      .map((id) => competence.find((item) => item.id === id)?.label)
                      .join(', ')}
                    // value={selectedItems.join(', ')}
                    readOnly
                  />

                  <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth>
                    <DialogTitle color={'black !important'}>Select Compétences clés</DialogTitle>
                    <DialogContent>
                      <TextField
                        sx={{ mt: 2 }}
                        label="Search"
                        fullWidth
                        size="small"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">🔍</InputAdornment>,
                        }}
                      />
                      <ListVirtualized
                        height={400}
                        itemCount={filteredItems.length}
                        itemSize={50}
                        width="100%"
                      >
                        {renderRowCompetence}
                      </ListVirtualized>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseDialog} color="primary">
                        Annuler
                      </Button>
                      <Button
                        onClick={handleCloseDialog}
                        color="primary"
                        disabled={selectedItems.length === 0}
                      >
                        Valider
                      </Button>
                    </DialogActions>
                  </Dialog>
                  {/* <FormControl sx={{ width: '-webkit-fill-available' }}>
                    <InputLabel id="competences-cles">Compétences clés</InputLabel>
                    <Select
                      labelId="competences-cles"
                      id="cles-multiple-checkbox"
                      multiple
                      value={personName}
                      onChange={handleChange}
                      input={<OutlinedInput label="Compétences clés" />}
                    
                      renderValue={(selected) =>
                        selected
                          .map(
                            (id) =>
                              competence.length > 0 &&
                              competence.find((name) => name.id === id).label,
                          )
                          .join(', ')
                      }
                      sx={{
                        '& #cles-multiple-checkbox': {
                          padding: '10px 14px',
                        },
                      }}
                    >
                      {competence.map((v) => (
                        <MenuItem key={v.id} value={v.id}>
                          <Checkbox checked={personName.includes(v.id)} />
                          <ListItemText primary={v.label} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                  <ComboBox
                    handleAutoComplete={(e, j) => {
                      setValue('Country', j)
                      setUpui(!upui)
                    }}
                    label="Pays"
                    data={getPays}
                    name="Country"
                    // required={true}
                    selectedValue={getValues('Country')}
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      // required: true,
                      size: 'small',
                      type: 'text',
                    }}
                    // rules={{ required: true }}
                    name="City"
                    label="Ville"
                  />
                </>
              ) : (
                ''
              )}
              {typeObject === 2 ? (
                <>
                  <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <Box sx={{ width: '100%' }}>
                      <ComboBox
                        handleAutoComplete={(e, j) => {
                          setValue('Entreprise', j)
                          setUpui(!upui)
                        }}
                        label="Organisation"
                        data={companys}
                        name="Entreprise"
                        required={true}
                        selectedValue={getValues('Entreprise')}
                      />
                    </Box>
                    <Box
                      sx={{
                        width: '30px',
                        marginTop: '12px',
                        display: 'flex',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        paddingX: '5px',
                      }}
                      onClick={() => setAddCompay(true)}
                    >
                      <AddIcon />
                    </Box>
                  </Box>

                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      required: true,
                      size: 'small',
                      type: 'text',
                    }}
                    rules={{ required: true }}
                    name="Name"
                    label="Intitulé poste ou formation (Name)"
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      type: 'date',
                      required: true,
                      size: 'small',
                    }}
                    InputLabelProps={{ shrink: true }}
                    rules={{ required: true }}
                    name="BeginDate"
                    label="Date de début"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) => {
                          setValue('CurrentPoste', e.target.checked)
                          setUpui(!upui)
                        }}
                        checked={getValues('CurrentPoste')}
                      />
                    }
                    label="Je fais cette formation actuellement"
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      type: 'date',
                      // required: false,
                      size: 'small',
                    }}
                    InputLabelProps={{ shrink: true }}
                    // rules={{ required: false }}
                    name="EndDate"
                    label="Date de fin"
                  />
                  <ComboBox
                    handleAutoComplete={(e, j) => {
                      setValue('ContractType', j.label)
                      setUpui(!upui)
                    }}
                    label="Type de contrat"
                    data={contractType}
                    name="ContractType"
                    // required={true}
                    selectedValue={contractType.find((e) => e.label === getValues('ContractType'))}
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      // required: true,
                      size: 'small',
                      type: 'text',
                    }}
                    // rules={{ required: true }}
                    name="Statut"
                    label="Statut"
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      // required: true,
                      size: 'small',
                      type: 'text',
                    }}
                    // rules={{ required: true }}
                    name="CollectiveAgre"
                    label="Convention collective"
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      // required: true,
                      // size: 'small',
                      type: 'text',
                    }}
                    rows={4}
                    multiline
                    // rules={{ required: true }}
                    name="GeneralInfo"
                    label="Desrciption"
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      // required: true,
                      size: 'small',
                      type: 'text',
                    }}
                    // rules={{ required: true }}
                    name="TyHours"
                    label="Type d'horaire"
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      // required: true,
                      size: 'small',
                      type: 'text',
                    }}
                    // rules={{ required: true }}
                    name="SubTHours"
                    label="Sous type horaire"
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      // required: true,
                      size: 'small',
                      type: 'number',
                    }}
                    // rules={{ required: true }}
                    name="hours"
                    label="Chiffre horaire"
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      // required: true,
                      size: 'small',
                      type: 'number',
                    }}
                    // rules={{ required: true }}
                    name="Gmsalary"
                    label="Salaire Brut"
                  />
                  <ComboBox
                    handleAutoComplete={(e, j) => {
                      setValue('GmsalaryF', j.label)
                      setUpui(!upui)
                    }}
                    label="Base frequence salaire brut"
                    data={gmsalaryF}
                    name="GmsalaryF"
                    // required={true}
                    selectedValue={gmsalaryF.find((e) => e.label === getValues('GmsalaryF'))}
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      // required: true,
                      size: 'small',
                      type: 'number',
                    }}
                    // rules={{ required: true }}
                    name="FinancialArrangement"
                    label="Prime, variable"
                  />
                  <Input
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      // required: true,
                      size: 'small',
                      type: 'text',
                    }}
                    rows={4}
                    multiline
                    // rules={{ required: true }}
                    name="Advantage"
                    label="Advantage"
                  />
                  <TextField
                    sx={{ mb: 2 }}
                    label="Compétences clés"
                    fullWidth
                    size="small"
                    onClick={handleOpenDialog}
                    value={selectedItems
                      .map((id) => competence.find((item) => item.id === id)?.label)
                      .join(', ')}
                    // value={selectedItems.join(', ')}
                    readOnly
                  />

                  <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth>
                    <DialogTitle color={'black !important'}>Select Compétences clés</DialogTitle>
                    <DialogContent>
                      <TextField
                        sx={{ mt: 2 }}
                        label="Search"
                        fullWidth
                        size="small"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">🔍</InputAdornment>,
                        }}
                      />
                      <ListVirtualized
                        height={400}
                        itemCount={filteredItems.length}
                        itemSize={50}
                        width="100%"
                      >
                        {renderRowCompetence}
                      </ListVirtualized>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseDialog} color="primary">
                        Annuler
                      </Button>
                      <Button
                        onClick={handleCloseDialog}
                        color="primary"
                        disabled={selectedItems.length === 0}
                      >
                        Valider
                      </Button>
                    </DialogActions>
                  </Dialog>
                  {/* <FormControl sx={{ width: '-webkit-fill-available' }}>
                    <InputLabel id="competences-cles">Compétences clés</InputLabel>
                    <Select
                      labelId="competences-cles"
                      id="cles-multiple-checkbox"
                      multiple
                      value={personName}
                      onChange={handleChange}
                      input={<OutlinedInput label="Compétences clés" />}                     
                      renderValue={(selected) =>
                        selected
                          .map(
                            (id) =>
                              competence.length > 0 &&
                              competence.find((name) => name.id === id).label,
                          )
                          .join(', ')
                      }
                      sx={{
                        '& #cles-multiple-checkbox': {
                          padding: '10px 14px',
                        },
                      }}
                    >
                      {competence.map((v) => (
                        <MenuItem key={v.id} value={v.id}>
                          <Checkbox checked={personName.includes(v.id)} />
                          <ListItemText primary={v.label} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                </>
              ) : (
                ''
              )}

              {/* <CustomButton onClick={handleClickOpen}>{'>'}-Ajouter document</CustomButton> */}
              {/* <CreateDocument setDocId={setDocId} setSubmit={setSubmit} />
              {docId && (
                <Typography
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    fontWeight: 500,
                    fontStyle: 'italic',
                  }}
                >
                  {docId.Nom}
                </Typography>
              )} */}
            </DialogContent>
            <DialogActions>
              <Button onClick={allowSubmit} type="submit">
                Valider
              </Button>
              <Button onClick={handleClose}>Annuler</Button>
            </DialogActions>
          </form>
        </Dialog>
      )}
    </>
  )
}
